<template>
    <Card>
        <div class="card-body">
            <router-link :to="{ name: 'OrderExpenseCreatePage'}" class="btn btn-link legitRipple">
                <i class="icon-plus3 mr-2"></i>{{ $t('buttons.add') }}
            </router-link>
        </div>
        <FetchTable
            :handle="tableHandle"
            :url="`/projects/${$route.params.projectUuid}/crm/orders/${this.$route.params.orderUuid}/expenses`"
            :columns="table.columns"              
        >
            <template #td-id="{ row }">
                <router-link
                    :to="{
                        name: 'OrderExpenseEditPage',
                        params: {
                            orderExpenseUuid: row.uuid
                        }
                    }">
                    {{ row.id }}
                </router-link>
            </template>
            <template #td-type="{ row }">
                <AppNullableCell>
                    <template #default v-if="row.type">
                        {{ $t('enums.OrderExpenseTypeEnum.' + row.type) }}
                    </template>
                </AppNullableCell>
            </template>
            <template #td-created_at="{ row }">
                {{ DateFormatter.formatDateTime(row.created_at) }}
            </template>
            <template #td-sum="{ row }">
                {{ Price.factory(row.sum).toCurrencyString("UAH") }}
            </template>
        </FetchTable>
    </Card>
</template>
<script>
import Card from "../../../../../components/new/CardComponent.vue";
import FetchTable from "../../../../../components/new/table/FetchTable.vue";
import { createTableHandle } from "../../../../../components/new/table/tableHandle";
import AppNullableCell from "../../../../components/tables/AppNullableCell.vue";

import Price from "../../../../../services/Price/Price";
import DateFormatter from "../../../../../services/DateFormatter";

export default {
    name: 'ExpensesIndexPage',
    components: {
        FetchTable, Card, DateFormatter, AppNullableCell
    },
    data() {
        return {
            tableHandle: createTableHandle(),
            DateFormatter,
            Price,
            table: {
                columns: [
                    { key: 'id', name: this.$t('table.titles.id'), width: '100px', type: 'string', order: true },
                    { key: 'name', name: this.$t('table.titles.name'), width: '300px', type: 'string', order: true },
                    { key: 'type', name: this.$t('table.titles.type'), width: '150px', type: 'string', order: false },
                    { key: 'sum', name: this.$t('table.titles.sum'), width: '150px', type: 'number', order: true },
                    { key: 'created_at', name: this.$t('table.titles.created_at'), width: '150px', type: 'string', order: true },
                ]
            }
        }
    },
    mounted() {
        this.tableHandle.fetchRows({
            order_uuids: [this.$route.params.orderUuid],
        });
    }
}
</script>